import { toTruncated } from '@/utilities/formatting';
import { Badge } from '@simplywallst/ui-core/next';

type Props = {
  prevFairValue: number;
  currentFairValue: number;
};

export const NarrativeUpdateFairValueBadge = ({
  prevFairValue,
  currentFairValue,
}: Props) => {
  const changePercentage =
    ((currentFairValue - prevFairValue) / prevFairValue) * 100;

  if (changePercentage === 0) return null;

  if (changePercentage < 0)
    return (
      <Badge tone="bad" variant="solid" size="small">
        Fair value Decreased {toTruncated(Math.abs(changePercentage), 0)}%
      </Badge>
    );

  return (
    <Badge tone="good" variant="solid" size="small">
      Fair value Increased {toTruncated(changePercentage, 0)}%
    </Badge>
  );
};
